"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _BlockButton = _interopRequireDefault(require("./BlockButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class CarouselControl extends _react.PureComponent {
  render() {
    const {
      disabled,
      onClick,
      direction,
      large,
      hintText
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_BlockButton.default, {
      className: "carousel-control",
      style: disabled ? {
        visibility: 'hidden'
      } : {},
      onClick: !disabled ? onClick : undefined
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: `fa${large ? ' fa-lg' : ''} fa-angle-${direction}`,
      "aria-hidden": "true"
    }), /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    }, hintText));
  }

}

exports.default = CarouselControl;
CarouselControl.propTypes = {
  disabled: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  direction: _propTypes.default.oneOf(['up', 'down', 'left', 'right']),
  large: _propTypes.default.bool,
  hintText: _propTypes.default.string
};